import React from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { usePayment } from "../context/payment";
import { useNavigate } from "react-router-dom";

function Message({ content }) {
  return <div>{content}</div>;
}

export default function PaymentButton() {
  const { paypalCreateOrder, handleTransaction, paypalMessage } = usePayment();
  const navigate = useNavigate();

  const onApprove = async (data, actions) => {
    await handleTransaction(data, actions);
    navigate("/warning");
  };

  return (
    <div className="paypal-buttons-container">
      <PayPalButtons
        className="paypal-buttons"
        style={{
          tagline: false,
          disableMaxWidth: true,
        }}
        createOrder={paypalCreateOrder}
        onApprove={onApprove}
      />
      <Message content={paypalMessage} />
    </div>
  );
}
